// Favre — strona kolekcji: filtry pod listą linii.
//  • Farbe — kółka; kolor z nazwy produktu (data-farbe, favre-card.liquid), bo kolor = osobny produkt.
//  • Rasse — psy pogrupowane wg rozmiaru legowiska (favre-rassen.liquid); wybór rasy zostawia produkty
//    z tym rozmiarem, a kafle pokazują cenę i linkują do wariantu w tym rozmiarze (data-groessen).
// Filtry łączą się ze sobą (I) i z linią (kolekcją), stan trzymamy w adresie: ?farbe=…&rasse=…
(() => {
  const grid = document.querySelector('.fc__grid');
  if (!grid) return;
  const kafle = [...grid.querySelectorAll('.fg__item')];
  const pusto = document.querySelector('[data-fc-pusto]');
  const licznik = document.querySelector('.fc__count');
  const fit = document.querySelector('[data-fc-fit]');
  const params = new URL(location.href).searchParams;

  // „1 Produkt” / „N Produkte” — wzory z tłumaczeń (count: 1 i count: 2)
  const tekstLicznika = (n) =>
    n === 1 ? licznik.dataset.wzor1 : (licznik.dataset.wzorN || '').replace(/\b2\b/, String(n));

  /* ---------------- dane kafli ---------------- */
  kafle.forEach((li) => {
    const a = li.querySelector('.fg__card');
    const cena = li.querySelector('.fg__price');
    li._href = a?.getAttribute('href') || '';
    li._cena = cena?.innerHTML || '';
    li._badge = li.querySelector('.fg__badge');
    li._groessen = {};
    (li.dataset.groessen || '').split(';').filter(Boolean).forEach((g) => {
      const [kod, id, dost, ...c] = g.split('|');
      li._groessen[kod.toUpperCase()] = { id, dostepny: dost === 'true', cena: c.join('|') };
    });
  });

  /* ---------------- kolory ---------------- */
  const PALETA = [
    // kolejność ma znaczenie: dłuższe/bardziej szczegółowe najpierw
    ['dunkelbraun/weiß', 'Braun/Weiß', 'linear-gradient(135deg, #5b3f2e 50%, #f4f1ec 50%)'],
    ['black/white', 'Schwarz/Weiß', 'linear-gradient(135deg, #1d1d1d 50%, #f4f1ec 50%)'],
    ['schwarz/weiß', 'Schwarz/Weiß', 'linear-gradient(135deg, #1d1d1d 50%, #f4f1ec 50%)'],
    ['schwarz/weiss', 'Schwarz/Weiß', 'linear-gradient(135deg, #1d1d1d 50%, #f4f1ec 50%)'],
    ['dunkelbraun', 'Dunkelbraun', '#4f3628'],
    ['dunkelblau', 'Dunkelblau', '#1f3550'],
    ['dunkelgrau', 'Dunkelgrau', '#4a4a4c'],
    ['hellgrau', 'Hellgrau', '#cfcfcf'],
    ['light rosa', 'Hellrosa', '#f1dcdc'],
    ['rose', 'Rosa', '#e9c6c6'],
    ['rosa', 'Rosa', '#e9c6c6'],
    ['pfrisch', 'Pfirsich', '#e7a08a'],
    ['pfirsich', 'Pfirsich', '#e7a08a'],
    ['schwarz', 'Schwarz', '#1d1d1d'],
    ['beige', 'Beige', '#d8c3a3'],
    ['creme', 'Creme', '#eee6d6'],
    ['petrol', 'Petrol', '#2f7a7c'],
    ['türkis', 'Türkis', '#5a9aa5'],
    ['tuerkis', 'Türkis', '#5a9aa5'],
    ['zimt', 'Zimt', '#c07a50'],
    ['braun', 'Braun', '#7a5741'],
    ['grün', 'Grün', '#55704c'],
    ['blau', 'Blau', '#5f88ad'],
    ['grau', 'Grau', '#9b9b9d'],
  ];
  const KOLEJNOSC = ['creme', 'beige', 'hellgrau', 'hellrosa', 'rosa', 'pfirsich', 'grün', 'türkis', 'petrol', 'blau', 'dunkelblau', 'grau',
    'dunkelgrau', 'zimt', 'braun', 'dunkelbraun', 'schwarz', 'braun/weiß', 'schwarz/weiß'];
  const rozpoznaj = (surowy) => {
    const s = (surowy || '').toLowerCase().trim();
    const t = PALETA.find(([k]) => s === k) || PALETA.find(([k]) => s.includes(k));
    if (t) return { klucz: t[1].toLowerCase(), etykieta: t[1], tlo: t[2] };
    return s ? { klucz: s, etykieta: surowy.trim(), tlo: '#e5e5e5' } : null;
  };

  const kolory = new Map();
  kafle.forEach((li) => {
    const k = rozpoznaj(li.dataset.farbe);
    li._kolor = k ? k.klucz : '';
    if (k && !kolory.has(k.klucz)) kolory.set(k.klucz, k);
  });
  // jeden kolor naraz (decyzja usera 2026-10-16 — bez łączenia kilku kolorów); stare linki z listą → pierwszy znany
  const wybraneKolory = new Set((params.get('farbe') || '').split(',').filter((k) => kolory.has(k)).slice(0, 1));

  const boxKolory = document.querySelector('[data-fc-farben]');
  const siatkaKolory = boxKolory?.querySelector('[data-fc-farben-grid]');
  const resetKolory = boxKolory?.querySelector('[data-fc-farben-reset]');

  if (boxKolory && kolory.size >= 2) {
    [...kolory.values()]
      .sort((a, b) => (KOLEJNOSC.indexOf(a.klucz) + 1 || 99) - (KOLEJNOSC.indexOf(b.klucz) + 1 || 99))
      .forEach((k) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fc__farbe';
        b.dataset.klucz = k.klucz;
        b.title = k.etykieta;
        b.setAttribute('aria-label', k.etykieta);
        b.setAttribute('aria-pressed', 'false');
        b.innerHTML = `<span class="fc__farbe-kolo" style="background:${k.tlo}"></span><span class="fc__farbe-nazwa">${k.etykieta}</span>`;
        b.addEventListener('click', () => {
          const byl = wybraneKolory.has(k.klucz);
          wybraneKolory.clear();
          if (!byl) wybraneKolory.add(k.klucz);
          zastosuj(true);
        });
        siatkaKolory.appendChild(b);
      });
    resetKolory?.addEventListener('click', () => {
      wybraneKolory.clear();
      zastosuj(true);
    });
    boxKolory.hidden = false;
  }

  /* ---------------- rasy ---------------- */
  const boxRasy = document.querySelector('[data-fc-rassen]');
  const przyciskiRas = boxRasy ? [...boxRasy.querySelectorAll('.fc__rasse')] : [];
  const resetRasy = boxRasy?.querySelector('[data-fc-rassen-reset]');
  const maRozmiary = kafle.some((li) => Object.keys(li._groessen).length);
  let rasa = przyciskiRas.find((b) => b.dataset.rasse === params.get('rasse')) || null;

  if (boxRasy && maRozmiary) {
    // ukryj rasy, dla których rozmiaru nie ma żaden produkt na tej stronie
    przyciskiRas.forEach((b) => {
      const jest = kafle.some((li) => li._groessen[b.dataset.groesse]);
      if (!jest) b.closest('.fc__rassen-row').hidden = true;
      b.addEventListener('click', () => {
        rasa = rasa === b ? null : b;
        zastosuj(true);
      });
    });
    resetRasy?.addEventListener('click', () => {
      rasa = null;
      zastosuj(true);
    });
    boxRasy.hidden = false;
  } else {
    rasa = null;
  }

  /* ---------------- zastosowanie obu filtrów ---------------- */
  function zastosuj(zapisz) {
    const rozmiar = rasa?.dataset.groesse || null;
    let widocznych = 0;

    kafle.forEach((li) => {
      const okKolor = !wybraneKolory.size || wybraneKolory.has(li._kolor);
      const wariant = rozmiar ? li._groessen[rozmiar] : null;
      const okRozmiar = !rozmiar || !!wariant;
      const ok = okKolor && okRozmiar;
      li.hidden = !ok;
      if (ok) widocznych++;

      // kafel w wybranym rozmiarze: link do wariantu, cena i dostępność tego wariantu
      const a = li.querySelector('.fg__card');
      const cena = li.querySelector('.fg__price');
      if (wariant) {
        // kafel może już linkować do wariantu (kolekcje „auswahl”) — podmieniamy, nie dopisujemy drugiego ?variant=
        const u = new URL(li._href, location.origin);
        u.searchParams.set('variant', wariant.id);
        a.setAttribute('href', u.pathname + u.search);
        cena.innerHTML = wariant.cena;
        ustawBadge(li, !wariant.dostepny);
      } else {
        a.setAttribute('href', li._href);
        cena.innerHTML = li._cena;
        ustawBadge(li, !!li._badge);
      }
    });

    // kolory
    siatkaKolory?.querySelectorAll('.fc__farbe').forEach((b) => {
      b.setAttribute('aria-pressed', wybraneKolory.has(b.dataset.klucz) ? 'true' : 'false');
    });
    boxKolory?.classList.toggle('is-active', wybraneKolory.size > 0);
    if (resetKolory) resetKolory.hidden = wybraneKolory.size === 0;

    // rasy
    przyciskiRas.forEach((b) => b.setAttribute('aria-pressed', b === rasa ? 'true' : 'false'));
    boxRasy?.classList.toggle('is-active', !!rasa);
    if (resetRasy) resetRasy.hidden = !rasa;
    if (fit) {
      fit.hidden = !rasa;
      if (rasa) {
        const nazwa = rasa.querySelector('span')?.textContent.trim() || '';
        fit.innerHTML = `<img src="${rasa.querySelector('img').src}" alt="" width="28" height="28">
          <span><strong>${nazwa}</strong> · ${fit.dataset.lSize}: <strong>${rasa.dataset.groesse}</strong>
          · ${rasa.dataset.aussen} cm (${fit.dataset.lInside} ${rasa.dataset.innen} cm)</span>`;
      }
    }

    if (pusto) pusto.hidden = widocznych > 0;
    if (licznik?.dataset.wzorN) licznik.textContent = tekstLicznika(widocznych);

    if (zapisz) {
      const url = new URL(location.href);
      if (wybraneKolory.size) url.searchParams.set('farbe', [...wybraneKolory].join(','));
      else url.searchParams.delete('farbe');
      if (rasa) url.searchParams.set('rasse', rasa.dataset.rasse);
      else url.searchParams.delete('rasse');
      history.replaceState(history.state, '', url);
    }
  }

  function ustawBadge(li, pokaz) {
    let b = li.querySelector('.fg__badge');
    if (pokaz && !b) {
      b = (li._badge || document.createElement('span'));
      if (!li._badge) {
        b.className = 'fg__badge';
        b.textContent = document.querySelector('[data-fc-sold]')?.dataset.fcSold || '';
      }
      li.querySelector('.fg__media').appendChild(b);
    } else if (!pokaz && b) {
      b.remove();
    }
  }

  zastosuj(false);
})();
